import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import styled from 'styled-components';
import Cookies from 'js-cookie';
import Footer from './components/Footer';
import Header from './components/Header';
import ConsultVehiclePDF from './sections/ConsultVehiclePDF';
import ExpectedResumePrice from './sections/ExpectedResumePrice';
import SectionCard from './components/SectionCard';
import VehicleCharacteristics from './components/VehicleCharacteristics';
import VehicleInfo from './components/VehicleInfo';
import AutofactStamp from './components/AutofactStamp';
import useMediaQuery from './useMediaQuery';
import AutofactStampDesk from './components/AutofactStampDesk';
import ModalMoreInfo from './components/ModalMoreInfo';
import { apiBaseUrl, authorizationCookie } from './config/config';
import Vehicles from './models/vehicles.model';
import RegularPrices from './models/regularPrices.model';
import Publications from './models/publications.model';
import ResidualPrices from './models/residualPrices.model';
import Adjustments from './models/adjustments.model';
import EquipmentPrices from './models/equipmentPrices.model';
import YearlyPrices from './models/yearlyPrices.model';
import VersionPrices from './models/versionPrices.model';
import VersionCompPrices from './models/versionCompPrices.model';
import ConditionalPriceAdjustmen from './sections/ConditionalPriceAdjustmen';
import ConditionPrices from './models/conditionPrices.model';
import AboutPrice from './sections/AboutPricePDF';
import { BlankSpace } from './genericComponents/layouts';
import placeholder from './assets/img/placeholder_inf_precios.png';
import TradeInPrices from './models/tradeInPrices.model';
import PlateInfo from './models/plateInfo.model';
import RankingChileautos from './models/rankingChileautos.model';
import Scoring from './models/scoring.model';
import ScoringSection from './sections/Scoring';
import HeroSection from './sections/HeroSection';
import KmSimulation from './models/KmSimulation.model';
import PublicationsSection from './sections/PublicationsPDF';
import SimilarVersions from './sections/SimilarVersions';
import YearPrices from './sections/YearPrices';
import RelatedIdGenModels from './models/RelatedIdGenModels';

const Body = styled.div`
  padding: 16px;
`;

type imgFormat = {
  id_foto: number
  url_s3: string
}

type InfoType = {
  createdAt?:string;
  resultsDate?:string;
  urlReport?:string;
  vehicle:Vehicles
  modelo_id?:number
  regular_price:RegularPrices
  publications:Publications
  residual_prices:ResidualPrices[]
  adjustments:Adjustments
  yearly_prices: YearlyPrices[]
  equipment_prices: EquipmentPrices[]
  version_prices:VersionPrices[]
  condition_prices:ConditionPrices
  seller_price?:RegularPrices
  model_images:string[]
  tradein_prices:TradeInPrices
  number_plate_info:PlateInfo
  public:boolean
  ranking_chileautos:RankingChileautos
  scoring?:Scoring
  price_new?:number | null
  version_comp_prices?:VersionCompPrices[]
  related_id_gen_models?:RelatedIdGenModels[]
  km_simulation?:KmSimulation
}

const info = {
  vehicle: {},
  regular_price: {},
  publications: {},
  residual_prices: [{}],
  adjustments: {},
  yearly_prices: [{}],
  equipment_prices: [{}],
  version_prices: [{}],
  condition_prices: {},
  tradein_prices: {},
  number_plate_info: {},
  scoring: {},
} as InfoType;
export default function ReportViewerPDF() {
  const [patenteInfoIsVisible, setPatenteInfoIsVisible] = useState(false);
  const [autofactStampVisible, setAutofactStampVisible] = useState(false);
  const [vehicleCharacteristics, setVehicleCharacteristics] = useState(false);
  const [infoJson, setInfoJson] = useState(info);
  const [loaded, setLoaded] = useState(false);

  const [haveSimilarVersions, setHaveSimilarVersions] = useState(false);
  const [haveYearPrices, setHaveYearPrices] = useState(false);

  const screenSize = useMediaQuery();
  const { id } = useParams();
  async function getJsonDataApi() {
    await fetch(`${apiBaseUrl}/price-report?id=${id}&jwt=${Cookies.get(authorizationCookie)}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }).then((response) => response.json())
      .then((data) => {
        const res = data.data;
        const images:string[] = [];
        (res.images).forEach((element:imgFormat) => {
          images.push(element.url_s3);
        });
        res.model_images = images;
        setInfoJson(res);
        setLoaded(true);
      }).catch((err) => console.log(err));
  }

  useEffect(() => {
    getJsonDataApi();
  }, []);
  const modelName = infoJson.vehicle.model_comp ? infoJson.vehicle.model_comp : infoJson.vehicle.model;
  const vehicleCompleteName = `${infoJson.vehicle.brand ?? ''} ${modelName ?? ''} ${infoJson.vehicle.year ?? ''} ${infoJson.vehicle.version ?? ''}`;
  if (patenteInfoIsVisible && screenSize < 700) {
    return (
      <ModalMoreInfo setVisible={setPatenteInfoIsVisible} textButton="INFORMACIÓN DE PATENTE">
        <VehicleInfo patente={infoJson.vehicle.patent ?? 'No aplica.'} />
      </ModalMoreInfo>
    );
  }
  if (vehicleCharacteristics && screenSize < 700) {
    return (
      <ModalMoreInfo setVisible={setVehicleCharacteristics} textButton="CARACTERÍSTICAS DEL VEHÍCULO">
        <VehicleCharacteristics />
      </ModalMoreInfo>
    );
  }
  if (autofactStampVisible && screenSize < 700) {
    return <AutofactStamp setVisible={setAutofactStampVisible} />;
  }
  const v = infoJson.vehicle.version ?? '';
  const t = infoJson.vehicle.transmission ?? '';
  const equipment = v.substring(v.indexOf(t));

  // recibiendo datos de publicaciones
  return (
    <div className="App">
      <Header createdAt={infoJson.createdAt} resultsDate={infoJson.resultsDate} id={id} urlReport={infoJson.urlReport} withActions={false} loaded={loaded} isPublicReport={infoJson.public} />
      <Body>
        <SectionCard title="Informe de precio y tasación:" startsOpen>
          <ConsultVehiclePDF
            vehicle={{
              carouselImages: infoJson.model_images ? infoJson.model_images : [placeholder],
              autofactPrice: infoJson.regular_price && infoJson.regular_price.autofact_value,
              completeName: vehicleCompleteName,
              patent: infoJson.number_plate_info.number,
              mileage: infoJson.vehicle.mileage,
              color: infoJson.vehicle.color,
              year: infoJson.vehicle.year,
              transmission: infoJson.vehicle.transmission,
              engine: infoJson.vehicle.engine,
              sinister: infoJson.number_plate_info.response?.remates.estado || false,
              technicalInspection: infoJson.number_plate_info.response?.revision_tecnica_vigente.estado || false,
              region: infoJson.vehicle.region,
            }}
          />
        </SectionCard>
        <SectionCard title="" startsOpen>
          <HeroSection
            setAutofactStampVisible={setAutofactStampVisible}
            vehicle={{
              completeName: vehicleCompleteName,
              autofactPrice: infoJson.regular_price.autofact_value ?? 0,
              maxPrice: infoJson.regular_price.max_value ?? 0,
              minPrice: infoJson.regular_price.min_value ?? 0,
              adjustSpecificVersion: infoJson.adjustments.specific_version_value ?? 0,
              year: infoJson.vehicle.year ?? 0,
              equipment: equipment || '',
              taxes: infoJson.vehicle.taxes || {},
              version: infoJson.vehicle.version ?? '',
            }}
            basePrices={infoJson.yearly_prices || []}
            equipmentPrices={infoJson.equipment_prices || []}
            mileage={{
              adjustPrice: infoJson.adjustments.mileage_value ?? 0,
              vehicleMilage: infoJson.vehicle.mileage ?? 0,
              referenceMileage: infoJson.vehicle.expected_mileage ?? 0,
            }}
            priceNew={infoJson.price_new ?? null}
            adjustRegion={infoJson.adjustments.region_value ?? 0}
            purchaseAvgPrice={infoJson.tradein_prices.average_value ?? null}
            region={{
              adjustPrice: infoJson.adjustments.region_value ?? 0,
              regionName: infoJson.adjustments.region_name ?? '',
            }}
            versionCompPrices={infoJson.version_comp_prices || []}
            marketPrices={{
              regularPrice: infoJson.regular_price,
            }}
            publications={infoJson.publications || []}
          />
        </SectionCard>
        <BlankSpace height="350px" />
        {
          infoJson.scoring && loaded
            ? (
              <SectionCard title="¿Debo ajustar el precio si tiene problemas legales?" startsOpen newSection>
                <ScoringSection
                  scoring={infoJson.scoring}
                  autofactPrice={infoJson.regular_price.autofact_value ?? 0}
                />
              </SectionCard>
            )
            : ''
        }
        <SectionCard title={`¿Cuál es el rango de precio esperado en parte de pago para ${vehicleCompleteName}?`} startsOpen>
          <ExpectedResumePrice
            vehicle={{
              completeName: vehicleCompleteName,
              clientPrice: infoJson.tradein_prices.client_value,
              avgPrice: infoJson.tradein_prices.average_value,
              minPrice: infoJson.tradein_prices.min_value,
              maxPrice: infoJson.tradein_prices.max_value,
              rules: infoJson.tradein_prices.rules,
              region: infoJson.vehicle.region,
              public: infoJson.public,
              year: infoJson.vehicle.year,
            }}
          />
        </SectionCard>
        <SectionCard title={`¿Cuál es la presencia de ${vehicleCompleteName} en publicaciones de venta?`} startsOpen>
          <PublicationsSection
            publications={infoJson.publications || []}
            rankingChileautos={infoJson.ranking_chileautos || false}
            createdAt={infoJson.createdAt}
            haveSimilarVersions={haveSimilarVersions}
            haveYearPrices={haveYearPrices}
          />
        </SectionCard>

        <SectionCard title={`¿Cuál es el precio de otras versiones similares a ${vehicleCompleteName}?`} startsOpen>
          <SimilarVersions
            versionCompPrices={infoJson.version_comp_prices || []}
            vehicle={{
              model: infoJson.vehicle.model ?? '',
              version: infoJson.vehicle.version ?? '',
              minPrice: infoJson.regular_price.min_value ?? 0,
              maxPrice: infoJson.regular_price.max_value ?? 0,
              autofactPrice: infoJson.regular_price.autofact_value ?? 0,
              modelId: infoJson.modelo_id ?? 0,
            }}
            setHaveSimilarVersions={setHaveSimilarVersions}
          />
        </SectionCard>

        <SectionCard title={`¿Cuál es el precio de ${infoJson.vehicle.brand ?? ''} ${infoJson.vehicle.model_comp ?? infoJson.vehicle.model ?? ''} ${infoJson.vehicle.version ?? ''} en diferentes años?`} startsOpen>
          <YearPrices
            key="year-prices"
            modelPricesIdGen={infoJson.related_id_gen_models || []}
            vehicle={{
              year: infoJson.vehicle.year ?? 0,
              model: infoJson.vehicle.model ?? '',
              version: infoJson.vehicle.version ?? '',
              minPrice: infoJson.regular_price.min_value ?? 0,
              maxPrice: infoJson.regular_price.max_value ?? 0,
              autofactPrice: infoJson.regular_price.autofact_value ?? 0,
            }}
            setHaveYearPrices={setHaveYearPrices}
          />
        </SectionCard>

        <SectionCard title="¿Cómo debo ajustar el precio según el estado del vehículo?" startsOpen>
          <ConditionalPriceAdjustmen
            vehicleCompleteName={vehicleCompleteName}
            conditionPrices={infoJson.condition_prices}
            residualPrices={infoJson.residual_prices}
            kmSimulation={infoJson.km_simulation ?? undefined}
            autofactPrice={infoJson.regular_price.autofact_value ?? 0}
          />
        </SectionCard>

        <SectionCard title="¿Sabes cómo garantizamos y construimos el mejor precio?" startsOpen>
          <AboutPrice
            publications={infoJson.publications || []}
          />
        </SectionCard>

      </Body>
      <Footer />
      <AutofactStampDesk visible={autofactStampVisible} setVisible={setAutofactStampVisible} />
    </div>
  );
}
